import { createFileRoute } from "@tanstack/react-router";
import GlobalSearch from "@/components/Search";

export const Route = createFileRoute("/_authenticated/search/")({
  component: GlobalSearch,
  staticData: { page: "search" },
});
